import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  /** Small uppercase kicker above the title, e.g. "Milestone 4". */
  kicker?: string;
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  kicker,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'relative flex flex-col items-start gap-3 overflow-hidden rounded-lg border border-hairline bg-elevated px-6 py-10',
        className,
      )}
    >
      <div
        aria-hidden="true"
        className="rule-grid pointer-events-none absolute inset-0 opacity-40"
      />
      <div className="relative flex flex-col items-start gap-3 max-w-prose">
        {Icon ? (
          <span className="flex size-9 items-center justify-center rounded-md border border-hairline bg-sunken text-ink-subtle">
            <Icon className="size-4" />
          </span>
        ) : null}
        {kicker ? <span className="section-label">{kicker}</span> : null}
        <h3 className="text-lede font-semibold tracking-tight text-ink">{title}</h3>
        {description ? (
          <div className="text-data leading-relaxed text-ink-muted">{description}</div>
        ) : null}
        {action ? <div className="pt-1">{action}</div> : null}
      </div>
    </div>
  );
}
